import React, { Component } from "react";
import {
    Grid,
    Row,
    Col,
    PanelGroup,
    Panel,
    Nav,
    NavItem,
    Tab
} from "react-bootstrap";

import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import * as loginActions from '../../actions/loginActions';

import Card from "../../components/Card/Card.jsx";
//import TCPDF from '../../documents/TRO-subscription-website-terms-and-conditions.pdf';

//Import our videos for the help pages
//import AddArtist from '../../documents/AddArtist.mp4';

//import Profile from "../../documents/Profile.mp4";
//import Tenants from "../../documents/Tenants.mp4";
//import Artists from "../../documents/Artists.mp4";
//import KioskUsers from "../../documents/KioskUsers.mp4";
//import Clauses from "../../documents/Clauses.mp4";
//import ConsentForms from "../../documents/ConsentForms.mp4";
//import Submissions from "../../documents/Submissions.mp4";

const Artists="http://www.gurueconsulting.com/videos/Artists.mp4";
const Profile="http://www.gurueconsulting.com/videos/Profile.mp4";
const Clauses="http://www.gurueconsulting.com/videos/Clauses.mp4";
const KioskUsers="http://www.gurueconsulting.com/videos/KioskUsers.mp4";
const ConsentForms="http://www.gurueconsulting.com/videos/ConsentForms.mp4";
const Submissions="http://www.gurueconsulting.com/videos/Submissions.mp4";

class OnlineHelp extends Component {
    static get contextTypes() {
        return {
            router: PropTypes.object
        };
    }
  render() {
      const tabsIconsProfile = (
          <Tab.Container id="tabs-with-dropdown" defaultActiveKey="overview">
              <Row className="clearfix">
                  <Col sm={12}>
                      <Nav bsStyle="tabs">
                          <NavItem eventKey="overview">
                              <i className="fa fa-info-circle" /> Overview
                          </NavItem>
                          <NavItem eventKey="profile">
                              <i className="fa fa-address-card" /> My Profile
                          </NavItem>
                          <NavItem eventKey="subscriptions">
                              <i className="fa fa-credit-card" /> Manage Subscriptions
                          </NavItem>
                      </Nav>
                  </Col>
                  <Col sm={12}>
                      <Tab.Content animation>
                          <Tab.Pane eventKey="overview">
                              TRO provides you with the ability to update important information about your profile.  Included
                              in your profile is basic information which includes your contact information, subscription plan details
                              and its status.  In addition, your profile stores your TRO login credentials and allows you to change your
                              password at any time. The information found on the tabs to the right will
                              provide you help on how to manage your profile information and subscription.
                          </Tab.Pane>
                          <Tab.Pane eventKey="profile">
                              You can access your profile information by clicking on the <a href="/#/profile">
                              <text className="text-primary">My Profile</text></a> link found on the main menu below your
                              avatar and name.  The My Profile form will open displaying two separate cards of information.
                              The first card contains your basic information including the subscription plan you are enrolled in and
                              your status.<br /><br />  To modify your subscription plan use the <a href="/#/mysubscription">
                              <text className="text-primary">Manage Subscription</text></a> accessed by clicking on the caret
                              icon <text className="caret" /> found next to the "My Profile" menu item.<br /><br />
                              The second card contains your user id and password.  You can use this card to update your
                              tenant password at any time. Each card has its own option to save information on the respective
                              card.  In addition if you edit information on all cards, there is a Save all cards option at
                               the bottom of the form.  <br /><br />Below is a video that demonstrates how to edit your profile:<br /><br />

                              <div>
                                  <video className="video-fluid z-depth-1 border=0" width="420" height="215" controls>
                                      <source src={Profile} type="video/mp4"/>
                                  </video>
                              </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="subscriptions">
                              An important part of TRO is providing the ability for you to manage your subscription.  This
                              includes allowing you to change your credit card information, cancel you existing subscription
                              and reactivate your subscription.  Each of these tasks are handled via the <a href="/#/mysubscription">
                              <text className="text-primary">Manage Subscription Wizard</text></a> which is accessed by
                              clicking on the caret icon <text className="caret" /> found next
                              to the "My Profile" menu item.  Once in the wizard you can
                              choose the type of change you would like to perform to your subscription and provide the
                              necessary information for us to complete your request.
                               <br /><br />Below is a video that demonstrates how to Manage your existing TRO subscription.<br /><br />
                              <div>
                                  <video className="video-fluid z-depth-1 border=0" width="420" height="215" controls>
                                      <source src={Profile} type="video/mp4"/>
                                  </video>
                              </div>
                          </Tab.Pane>
                      </Tab.Content>
                  </Col>
              </Row>
          </Tab.Container>
      );
      const tabsIconsArtists = (
          <Tab.Container id="tabs-with-dropdown" defaultActiveKey="overview">
              <Row className="clearfix">
                  <Col sm={12}>
                      <Nav bsStyle="tabs">
                          <NavItem eventKey="overview">
                              <i className="fa fa-info-circle" /> Overview
                          </NavItem>
                          <NavItem eventKey="add">
                              <i className="fa fa-plus" /> Add Artist
                          </NavItem>
                          <NavItem eventKey="update">
                              <i className="fa fa-edit" /> Update Artist
                          </NavItem>
                          <NavItem eventKey="delete">
                              <text className="text-danger"><i className="fa fa-times"/></text> Delete Artist
                          </NavItem>
                      </Nav>
                  </Col>
                  <Col sm={12}>
                      <Tab.Content animation>
                          <Tab.Pane eventKey="overview">
                              TRO allows you to setup and store all the artists that perform services with your shop.
                              The artists are then selected when a client is completing a consent form to capture
                              which artist performed the work.  The information found on the tabs to the right will
                              provide you help on how to add, update and delete your artists.
                          </Tab.Pane>
                          <Tab.Pane eventKey="add">
                              Adding an artist is very straight forward.  You can access the <a href="/#/addartist">
                              <text className="text-primary">add artist</text></a> option from
                              two different locations found on the main menu below your login avatar.  First option
                              is to click on the "Manage Artists" menu which will display a table of your current
                              artists. If you have any existing artists listed in the table you will see a small blue
                              plus sign <text className="text-info"><i className="fa fa-plus"/></text> to the right of each artists, this icon when selected will fire off the
                              "Add Artist" form.  <br /><br />If you do not have any artists added to your tenant, then you can
                              also click on the small down caret icon <text className="caret" /> located to the right of the "Manage Artists"
                              menu option.  A new sub-menu will appear allowing you to select the "Add Artist" option
                              which will open the <a href="/#/addartist">
                              <text className="text-primary">Add Artist</text></a> form.
                              Once you are on the Add Artist form, simply fill out the form with the new artist
                              information and click the "Save" button. <br /><br />Below is a video that demonstrates how to add an artist:<br /><br />

                              <div>
                                  <video className="video-fluid z-depth-1 border=0" width="420" height="215" controls>
                                      <source src={Artists} type="video/mp4"/>
                                  </video>
                              </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="update">
                              To update an artist you simply click on the "Manage Artists" menu which will display a <a href="/#/artists">
                              <text className="text-primary">table of your current artists</text></a>. In this table you can find the
                              artist you would like to update and click on the blue
                              edit icon <text className="text-info"><i className="fa fa-edit"/></text> found on the right side of the row
                              that the artist is displayed on.
                              Once you are on the Update Artist form, simply update the artist information with the new
                              information and click the "Save" button. <br /><br />Below is a video that demonstrates how to update an artist:<br /><br />

                              <div>
                                  <video className="video-fluid z-depth-1 border=0" width="420" height="215" controls>
                                      <source src={Artists} type="video/mp4"/>
                                  </video>
                              </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="delete">
                              To delete an artist you simply click on the "Manage Artists" menu which will display a <a href="/#/artists">
                              <text className="text-primary">table of your current artists</text></a>. In this table you can
                              find the artist you would like to delete and click on the red delete icon
                              <text className="text-danger"><i className="fa fa-times " /></text>found on the right side of the row that the artist is displayed on.
                              You will be asked to confirm your deletion request and once you agree to delete the record, it will be
                              removed from you artist table.  <br /><br />Below is a video that demonstrates how to delete an artist:<br /><br />

                              <div>
                                  <video className="video-fluid z-depth-1 border=0" width="420" height="215" controls>
                                      <source src={Artists} type="video/mp4"/>
                                  </video>
                              </div>
                          </Tab.Pane>
                      </Tab.Content>
                  </Col>
              </Row>
          </Tab.Container>
      );
      const tabsIconsKioskUsers = (
          <Tab.Container id="tabs-with-dropdown" defaultActiveKey="overview">
              <Row className="clearfix">
                  <Col sm={12}>
                      <Nav bsStyle="tabs">
                          <NavItem eventKey="overview">
                              <i className="fa fa-info-circle" /> Overview
                          </NavItem>
                          <NavItem eventKey="add">
                              <i className="fa fa-plus" /> Add Kiosk User
                          </NavItem>
                          <NavItem eventKey="update">
                              <i className="fa fa-edit" /> Update Kiosk User
                          </NavItem>
                          <NavItem eventKey="delete">
                              <text className="text-danger"><i className="fa fa-times"/></text> Delete Kiosk User
                          </NavItem>
                      </Nav>
                  </Col>
                  <Col sm={12}>
                      <Tab.Content animation>
                          <Tab.Pane eventKey="overview">
                              TRO allows you to setup and store all your Kiosk User Ids.  Kiosk users are a special login
                              that is used on your public facing consent devices.  Kiosk users allow you to provide a login
                              that runs in Kiosk Mode which does not allow any functions other than rendering and processing
                              your consent forms.  This approach protects your main tenant functions from being exposed and
                              accessed by your clients who are submitting consent forms. During registration, the TRO staff created your first Kiosk user for
                              you with the credentials that were provided. The information found on the tabs to the right will
                              provide help on how to add, update and delete Kiosk users.
                          </Tab.Pane>
                          <Tab.Pane eventKey="add">
                              Adding a Kiosk user is very straight forward.  You can access the <a href="/#/addkioskuser">
                              <text className="text-primary">add kiosk user</text></a> option from
                              two different locations found on the main menu below your login avatar.  First option
                              is to click on the "Manage Kiosk Users" menu which will display a table of your current
                              Kiosk users. If you have any existing users listed in the table you will see a small blue
                              plus sign <text className="text-info"><i className="fa fa-plus"/></text> to the right of each user, this
                              icon when selected will fire off the
                              "Add Kiosk User" form.  <br /><br />If you do not have any users added to your tenant, then you can
                              also click on the small down caret icon <text className="caret" /> located to the right of the "Manage Kiosk Users"
                              menu option.  A new sub-menu will appear allowing you to select the "Add Kiosk User" option
                              which will open the <a href="/#/addkioskuser">
                              <text className="text-primary">Add Kiosk User</text></a> form.
                              Once you are on the Add Kiosk User form, simply fill out the form with the new user
                              information and click the "Save" button. <br /><br />Below is a video that demonstrates how to add a Kiosk user:<br /><br />

                              <div>
                                  <video className="video-fluid z-depth-1 border=0" width="420" height="215" controls>
                                      <source src={KioskUsers} type="video/mp4"/>
                                  </video>
                              </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="update">
                              To update a Kiosk user you simply click on the "Manage Kiosk Users" menu which will display a <a href="/#/kioskusers">
                              <text className="text-primary">table of your current users</text></a>. In this table you can find the
                              user you would like to update and click on the blue
                              edit icon <text className="text-info"><i className="fa fa-edit"/></text> found on the right side of the row
                              that the user is displayed on.
                              Once you are on the Update Kiosk User form, simply update the user information with the new
                              information and click the "Save" button. <br /><br />Below is a video that demonstrates how to update a Kiosk user:<br /><br />

                              <div>
                                  <video className="video-fluid z-depth-1 border=0" width="420" height="215" controls>
                                      <source src={KioskUsers} type="video/mp4"/>
                                  </video>
                              </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="delete">
                              To delete a kiosk user you simply click on the "Manage Kiosk Users" menu which will display a <a href="/#/kioskusers">
                              <text className="text-primary">table of your current users</text></a>. In this table you can
                              find the user you would like to delete and click on the red delete icon
                              <text className="text-danger"><i className="fa fa-times " /></text>found on the right side of the row that the user is displayed on.
                              You will be asked to confirm your deletion request and once you agree to delete the record, it will be
                              removed from you Kiosk user table.  <br /><br />Below is a video that demonstrates how to delete a Kiosk user:<br /><br />

                              <div>
                                  <video className="video-fluid z-depth-1 border=0" width="420" height="215" controls>
                                      <source src={KioskUsers} type="video/mp4"/>
                                  </video>
                              </div>
                          </Tab.Pane>
                      </Tab.Content>
                  </Col>
              </Row>
          </Tab.Container>
      );
      const tabsIconsClauses = (
          <Tab.Container id="tabs-with-dropdown" defaultActiveKey="overview">
              <Row className="clearfix">
                  <Col sm={12}>
                      <Nav bsStyle="tabs">
                          <NavItem eventKey="overview">
                              <i className="fa fa-info-circle" /> Overview
                          </NavItem>
                          <NavItem eventKey="add">
                              <i className="fa fa-plus" /> Add Clauses
                          </NavItem>
                          <NavItem eventKey="update">
                              <i className="fa fa-edit" /> Update Clauses
                          </NavItem>
                          <NavItem eventKey="delete">
                              <text className="text-danger"><i className="fa fa-times"/></text> Delete Clause
                          </NavItem>
                      </Nav>
                  </Col>
                  <Col sm={12}>
                      <Tab.Content animation>
                          <Tab.Pane eventKey="overview">
                              TRO allows you to setup and store all your consent form clauses.
                              These clause are then acknowledged and consented to when a client is completing a consent
                              form.  These clauses are also used when creating consent forms allowing them to be attached to
                              a consent form and ordered as you see fit. The information found on the tabs to the right will
                              provide you help on how to add, update and delete your consent form clauses.
                          </Tab.Pane>
                          <Tab.Pane eventKey="add">
                              Adding a consent clause is very straight forward.  You can access the <a href="/#/addclause">
                              <text className="text-primary">add consent clause</text></a> option from
                              two different locations found on the main menu below your login avatar.  First option
                              is to click on the "Manage Clauses" menu which will display a table of your current
                              consent clauses. If you have any existing clauses listed in the table you will see a small blue
                              plus sign <text className="text-info"><i className="fa fa-plus"/></text> to the right of each clause, this
                              icon when selected will fire off the
                              "Add Clause" form.  <br /><br />If you do not have any clauses added to your tenant, then you can
                              also click on the small down caret icon <text className="caret" /> located to the right of the "Manage Clauses"
                              menu option.  A new sub-menu will appear allowing you to select the "Add Clause" option
                              which will open the <a href="/#/addclause">
                              <text className="text-primary">Add Clause</text></a> form.
                              Once you are on the Add Clause form, simply fill out the form with the new clause
                              information and click the "Save" button. <br /><br />
                              It is worth noting that setting the clause to "Required" will require the client to agree
                              to the clause before proceeding when completing a consent submission.  Also, the "Type of Consent"
                              field allows you to decided whether the consent is a simple checkbox or a YES/NO Checkbox. It is also
                              a good idea to give your consent clauses unique and simple names which will simplify the process of
                              attaching and ordering them when you create your consent form(s).
                              <br /><br />Below is a video that demonstrates how to add a consent form clause:<br /><br />

                              <div>
                                  <video className="video-fluid z-depth-1 border=0" width="420" height="215" controls>
                                      <source src={Clauses} type="video/mp4"/>
                                  </video>
                              </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="update">
                              To update a consent clause you simply click on the "Manage Clauses" menu which will display a <a href="/#/clauses">
                              <text className="text-primary">table of your current consent clauses</text></a>. In this table you can find the
                              clause you would like to update and click on the blue
                              edit icon <text className="text-info"><i className="fa fa-edit"/></text> found on the right side of the row
                              that the clause is displayed on.
                              Once you are on the Update Clause form, simply update the clause information with the new
                              information and click the "Save" button. <br /><br />
                              It is worth noting that setting the clause to "Required" will require the client to agree
                              to the clause before proceeding when completing a consent submission.  Also, the "Type of Consent"
                              field allows you to decided whether the consent is a simple checkbox or a YES/NO Checkbox. It is also
                              a good idea to give your consent clauses unique and simple names which will simplify the process of
                              attaching and ordering them when you create your consent form(s).
                              <br /><br />Below is a video that demonstrates how to update a consent form clause:<br /><br />

                              <div>
                                  <video className="video-fluid z-depth-1 border=0" width="420" height="215" controls>
                                      <source src={Clauses} type="video/mp4"/>
                                  </video>
                              </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="delete">
                              To delete a consent clause you simply click on the "Manage Clauses" menu which will display a <a href="/#/clauses">
                              <text className="text-primary">table of your current consent clauses</text></a>. In this table you can
                              find the clause you would like to delete and click on the red delete icon
                              <text className="text-danger"><i className="fa fa-times " /></text>found on the right side of the row that the clause is displayed on.
                              You will be asked to confirm your deletion request and once you agree to delete the record, it will be
                              removed from you consent clauses table.  <br /><br />Below is a video that demonstrates how to delete a consent clause:<br /><br />

                              <div>
                                  <video className="video-fluid z-depth-1 border=0" width="420" height="215" controls>
                                      <source src={Clauses} type="video/mp4"/>
                                  </video>
                              </div>
                          </Tab.Pane>
                      </Tab.Content>
                  </Col>
              </Row>
          </Tab.Container>
      );
      const tabsIconsConsentForms = (
          <Tab.Container id="tabs-with-dropdown" defaultActiveKey="overview">
              <Row className="clearfix">
                  <Col sm={12}>
                      <Nav bsStyle="tabs">
                          <NavItem eventKey="overview">
                              <i className="fa fa-info-circle" /> Overview
                          </NavItem>
                          <NavItem eventKey="add">
                              <i className="fa fa-plus" /> Add Consent Form
                          </NavItem>
                          <NavItem eventKey="update">
                          <i className="fa fa-edit" /> Update Consent Form
                          </NavItem>
                          <NavItem eventKey="display">
                              <i className="fa fa-desktop" /> Display Consent Form
                          </NavItem>
                          <NavItem eventKey="delete">
                              <text className="text-danger"><i className="fa fa-times"/></text> Delete Consent Form
                          </NavItem>
                      </Nav>
                  </Col>
                  <Col sm={12}>
                      <Tab.Content animation>
                          <Tab.Pane eventKey="overview">
                              TRO allows you to setup and store all your consent forms. These forms are created by configuring
                              form settings, behavior and configuring which artists and clauses are provided when the form
                              is rendered for a client consent event.  The consent forms can be displayed in both tenant
                              mode and Kiosk mode but it is recommended that you always display your consent forms while in
                              Kiosk mode. The information found on the tabs to the right will
                              provide you help on how to add, update and delete your consent forms.
                          </Tab.Pane>
                          <Tab.Pane eventKey="add">
                              Adding a consent form is very straight forward.  You can access the <a href="/#/addconsent">
                              <text className="text-primary">add consent form</text></a> option from
                              two different locations found on the main menu below your login avatar.  First option
                              is to click on the "Manage Consent Forms" menu which will display a table of your current
                              consent forms. If you have any existing consent forms listed in the table you will see a small blue
                              plus sign <text className="text-info"><i className="fa fa-plus"/></text> to the right of each form, this
                              icon when selected will fire off the
                              "Add Consent Form" form.  <br /><br />If you do not have any consent forms added to your tenant, then you can
                              also click on the small down caret icon <text className="caret" /> located to the right of the "Manage Consent Forms"
                              menu option.  A new sub-menu will appear allowing you to select the "Add Consent Form" option
                              which will open the <a href="/#/addconsent">
                              <text className="text-primary">Add Consent Form</text></a> form.
                              Once you are on the Add Consent Form form, simply fill out the form with the new consent form
                              information and click the "Save" button. <br /><br />

                              Adding a consent form is the most involved process in TRO.  However, it should be noted that each panel
                              can be expanded to provide you with the configuration settings required to add a consent form.  Watch the
                              video below to see how to configure a consent form, add artists, add/order consent clauses and understand
                              how each setting in the form affects the behavior of the form when it is displayed.

                              <br /><br />Below is a video that demonstrates how to add a consent form:<br /><br />

                              <div>
                                  <video className="video-fluid z-depth-1 border=0" width="420" height="215" controls>
                                      <source src={ConsentForms} type="video/mp4"/>
                                  </video>
                              </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="update">
                              To update a consent form you simply click on the "Manage Consent Forms" menu which will display a <a href="/#/consents">
                              <text className="text-primary">table of your current consent forms</text></a>. In this table you can find the
                              consent form you would like to update and click on the blue
                              edit icon <text className="text-info"><i className="fa fa-edit"/></text> found on the right side of the row
                              that the consent form is displayed on.
                              Once you are on the Update Consent Form form, simply update the consent form information with the new
                              information and click the "Save" button. <br /><br />


                              Updating a consent form is very similar to adding one, basically you are updating the form settings,
                              adding/deleting/reording consent clauses and adding/deleting artists.  It should be noted that if you make changes
                              to artists or consent clauses stored in your tenant, you must open and at least save the consent form to reflect
                              those changes.  If you add new artists or consent clauses to your tenant you must also edit the consent forms that
                              you would like the new artists and clauses to be displayed by and add them, remembering to set the order of your clauses.

                              <br /><br />Watch the video provided below for a detailed demonstration of how to add new artists and clauses to a consent
                              form.  The video will also illustrate what happens when you delete an artist or a clause from the tenant and how those
                              deletions are reflected on the consent form.

                              <br /><br />Below is a video that demonstrates how to update a consent form:<br /><br />

                              <div>
                                  <video className="video-fluid z-depth-1 border=0" width="420" height="215" controls>
                                      <source src={ConsentForms} type="video/mp4"/>
                                  </video>
                              </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="display">
                              To display a consent form you simply click on the "Manage Consent Forms" menu which will display a <a href="/#/consents">
                              <text className="text-primary">table of your current consent forms</text></a>. In this table you can find the
                              consent form you would like to display and click on the blue
                              display icon <text className="text-info"><i className="fa fa-desktop"/></text> found on the right side of the row
                              that the consent form is displayed on. The Display Consent Wizard will start up walking your client through
                              the details and consents required by your form.  This is a multi-step wizard ending with the successful submittal
                              of your consent form.  During the submittal you client and a guardian may be required to sign the form as well as
                              take a picture of their State Issued photo ID.  The behavior of this form is controlled by how
                              you created your form and the options that you set.
                              <br /><br />Once the submission has been saved you can always access the submission from the
                              "Submissions" menu option to accomodate repeat visits from your client.

                              <br /><br />Below is a video that demonstrates how to display a consent form:<br /><br />

                              <div>
                                  <video className="video-fluid z-depth-1 border=0" width="420" height="215" controls>
                                      <source src={ConsentForms} type="video/mp4"/>
                                  </video>
                              </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="delete">
                              To delete a consent form you simply click on the "Manage Consent Forms" menu which will display a <a href="/#/consents">
                              <text className="text-primary">table of your current consent forms</text></a>. In this table you can
                              find the consent form you would like to delete and click on the red delete icon
                              <text className="text-danger"><i className="fa fa-times " /></text>found on the right side of the row that the consent form is displayed on.
                              You will be asked to confirm your deletion request and once you agree to delete the record, it will be
                              removed from you consent forms table.  <br /><br />Below is a video that demonstrates how to delete a consent form:<br /><br />

                              <div>
                                  <video className="video-fluid z-depth-1 border=0" width="420" height="215" controls>
                                      <source src={ConsentForms} type="video/mp4"/>
                                  </video>
                              </div>
                          </Tab.Pane>
                      </Tab.Content>
                  </Col>
              </Row>
          </Tab.Container>
      );
      const tabsIconsSubmissions = (
          <Tab.Container id="tabs-with-dropdown" defaultActiveKey="overview">
              <Row className="clearfix">
                  <Col sm={12}>
                      <Nav bsStyle="tabs">
                          <NavItem eventKey="overview">
                              <i className="fa fa-info-circle" /> Overview
                          </NavItem>
                          <NavItem eventKey="display">
                              <i className="fa fa-desktop" /> Display Submission
                          </NavItem>
                          <NavItem eventKey="delete">
                              <text className="text-danger"><i className="fa fa-times"/></text> Delete Submission
                          </NavItem>
                      </Nav>
                  </Col>
                  <Col sm={12}>
                      <Tab.Content animation>
                          <Tab.Pane eventKey="overview">
                              TRO allows you to store all your client consent submssions online.  The My Submissions
                              feature allows you to look at the last 50 submissions by default but also query your submissions
                              by using an artist name, a client name or a client's date of birth.  In addition, when displaying
                              an existing submission, you are allowed to edit the health department notes field to update a return
                              client's information keeping them from having to submit a consent each time they visit your shop. Simply
                              find their last submission, display it and scroll down to the notes field and update it with
                              the new information, clicking the update button at the bottom of the form to save your changes.
                              The information found on the tabs to the right will provide you help on how to view and delete your
                              consent submissions.
                          </Tab.Pane>
                          <Tab.Pane eventKey="display">
                              To display a consent submission you simply click on the "Submissions" menu which will display a <a href="/#/submissions">
                              <text className="text-primary">table of your current consent submissions</text></a>. In this table you can find the
                              consent submission you would like to update and click on the blue
                              display icon <text className="text-info"><i className="fa fa-desktop"/></text> found on the right side of the row
                              that the consent submission is displayed on.
                              Once you are on the "Our Consent Submissions" form, simply update the consent submission Health Department Notes with
                              new information for this client and click the "Update" button. <br /><br />


                              As noted in the Overview section, client submissions' Notes field can be edited.  The purpose
                              of this is to allow you to edit an existing client consent submission, adding new health department
                              information for the current visit without requiring another consent submission.<br/><br />

                              In addition, this form will default to displaying your last 50 submissions.  However, you can always
                              access the query field and search for submissions by artist name, exact client name or the client's
                              date of birth.  The latter is preferred since it will find the last 50 submissions matching the
                              provided date of birth.  Using client name to look up a client is NOT a partial match and is
                              case sensitive.  In other words it must match the client's name exactly as it was stored when
                              they submitted the consent submission.

                              <br /><br />Below is a video that demonstrates how to display a consent submission:<br /><br />

                              <div>
                                  <video className="video-fluid z-depth-1 border=0" width="420" height="215" controls>
                                      <source src={Submissions} type="video/mp4"/>
                                  </video>
                              </div>
                          </Tab.Pane>
                          <Tab.Pane eventKey="delete">
                              To delete a consent submission you simply click on the "Submissions" menu which will display a <a href="/#/submissions">
                              <text className="text-primary">table of your current consent submissions</text></a>. In this table you can
                              find the consent submission you would like to delete and click on the red delete icon
                              <text className="text-danger"><i className="fa fa-times " /></text>found on the right side of the row that the consent submission is displayed on.
                              You will be asked to confirm your deletion request and once you agree to delete the record, it will be
                              removed from you consent submissions table.  <br /><br />Below is a video that demonstrates how to delete a consent submission:<br /><br />

                              <div>
                                  <video className="video-fluid z-depth-1 border=0" width="420" height="215" controls>
                                      <source src={Submissions} type="video/mp4"/>
                                  </video>
                              </div>
                          </Tab.Pane>
                      </Tab.Content>
                  </Col>
              </Row>
          </Tab.Container>
      );
      const tabsIconsFAQ = (
          <Tab.Container id="tabs-with-dropdown" defaultActiveKey="FAQ">
              <Row className="clearfix">
                  <Col sm={12}>
                      <Nav bsStyle="tabs">
                          <NavItem eventKey="FAQ">
                              <i className="fa fa-question-circle" /> Frequently Asked Questions
                          </NavItem>
                      </Nav>
                  </Col>
                  <Col sm={12}>
                      <Tab.Content animation>
                          <Tab.Pane eventKey="FAQ">
                              <p className="category">What is TRO?</p>
                              <blockquote>
                                  <p>
                                      Tattoo Release Online (TRO) is a Software as a Service product
                                      for managing Tattoo Consent Form submissions online.
                                  </p>
                              </blockquote>
                              <p className="category">How much does TRO cost?</p>
                              <blockquote>
                                  <p>
                                      We offer different plans to meet your needs, please refer our TRO <a href="#/pages/pricing-page">Pricing Options
                                  </a> for more details.
                                  </p>
                              </blockquote>
                              <p className="category">How do I sign up for TRO?</p>
                              <blockquote>
                                  <p>
                                      You can setup your TRO subscription by using our <a href="#/register">Registration Wizard.</a>
                                  </p>
                              </blockquote>
                              <p className="category">How do cancel or edit my subscription with TRO?</p>
                              <blockquote>
                                  <p>
                                      Using the "Manage Subscription" sub-menu located under the Profile menu of your TRO
                                      tenant you can request to Cancel, Change your credit card information or reactivate your
                                      TRO subscription.
                                  </p>
                              </blockquote> <p className="category">Can I edit or delete my client consent submissions?</p>
                              <blockquote>
                                  <p>
                                      You can update or delete your client consent submissions at any time from your tenant
                                      login.  Updating your submission allows your client to not have to submit a new consent
                                      each time they visit your shop and artist.
                                  </p>
                              </blockquote>
                          </Tab.Pane>
                      </Tab.Content>
                  </Col>
              </Row>
          </Tab.Container>
      );
      const pageSubcategories = (
          <Tab.Container id="nav-with-icons" defaultActiveKey="GettingStarted">
              <div>
                  <div className="nav-container">
                      <Nav bsStyle="tabs" bsClass="nav nav-icons">
                          <NavItem eventKey="GettingStarted">
                              <i className="fa fa-info-circle" />
                              <br /> Getting Started
                          </NavItem>
                          <NavItem eventKey="Profile">
                              <i className="fa fa-address-card" />
                              <br /> Your Profile
                          </NavItem>
                          <NavItem eventKey="Kiosk">
                              <i className="fa fa-users" />
                              <br /> Kiosk Users
                          </NavItem>
                          <NavItem eventKey="Artists">
                              <i className="fa fa-users" />
                              <br /> Artists
                          </NavItem>
                          <NavItem eventKey="Clauses">
                              <i className="fa fa-language" />
                              <br /> Clauses
                          </NavItem>
                          <NavItem eventKey="ConsentForms">
                              <i className="fa fa-newspaper-o" />
                              <br /> Consent Forms
                          </NavItem>
                          <NavItem eventKey="Submissions">
                              <i className="fa fa-upload" />
                              <br /> Submissions
                          </NavItem>
                          <NavItem eventKey="FAQ">
                              <i className="fa fa-question-circle" />
                              <br /> FAQ
                          </NavItem>
                      </Nav>
                  </div>
                  <Tab.Content>
                      <Tab.Pane eventKey="GettingStarted">
                          <Card
                              title="Getting Started with TRO!"
                              category=""
                              content={
                                  <div>
                                      <p>
                                          If you have just logged into your new tenant after registering with TRO,
                                          you will notice that there are a few things that you need to do first before
                                          you can start storing your consent forms online.  The documentation found
                                          on these pages will help you navigate these initial steps as well as provide
                                          you with guidance on how to manage your TRO tenant.
                                      </p>
                                      <p>
                                          In a nutshell, the following items need to be done to setup TRO for the
                                          first time:
                                          <ul>
                                              <li>
                                                  Take a look at your <a href="/#/profile"><text className="text-primary">Profile</text></a> and make sure all that your information is correct
                                              </li>
                                              <li>
                                                  Look at your <a href="/#/kioskusers"><text className="text-primary">Kiosk Users</text></a>, we created the first one for you!
                                              </li>
                                              <li>
                                                  Add your <a href="/#/artists"><text className="text-primary">Artists</text></a>, see our documentation on how to do this above.
                                              </li>
                                              <li>
                                                  Add your <a href="/#/clauses"><text className="text-primary">Consent Clauses</text></a>, see our documentation on how to do this above.
                                              </li>
                                              <li>
                                                  Build your first <a href="/#/consents"><text className="text-primary">Consent Form</text></a>, attaching your Artists and Clauses to the form,
                                                  see our documentation on how to do this above.
                                              </li>
                                              <li>
                                                  Log into Kiosk Mode and render your new consent form
                                              </li>
                                              <li>
                                                  Log into Tenant mode and view you consent form that is stored online
                                              </li>
                                              <li>
                                                  That is all there is too it!
                                              </li>
                                          </ul>
                                      </p>
                                  </div>
                              }
                          />
                      </Tab.Pane>
                      <Tab.Pane eventKey="Profile">
                          <Card
                              title="Your Profile"
                              category="Help Documentation for managing your profile and subscription"
                              ctFullWidth
                              content={tabsIconsProfile}
                          />
                      </Tab.Pane>
                      <Tab.Pane eventKey="Kiosk">
                          <Card
                              title="Manage Kiosk Users"
                              category="Help Documentation for managing your kiosk users"
                              ctFullWidth
                              content={tabsIconsKioskUsers}
                          />
                      </Tab.Pane>
                      <Tab.Pane eventKey="Artists">
                          <Card
                              title="Manage Artists"
                              category="Help Documentation for managing your artists"
                              ctFullWidth
                              content={tabsIconsArtists}
                          />
                      </Tab.Pane>
                      <Tab.Pane eventKey="Clauses">
                          <Card
                              title="Manage Clauses"
                              category="Help Documentation for managing your consent clauses"
                              ctFullWidth
                              content={tabsIconsClauses}
                          />
                      </Tab.Pane>

                      <Tab.Pane eventKey="ConsentForms">
                          <Card
                              title="Manage Consent Forms"
                              category="Help Documentation for managing your consent forms"
                              ctFullWidth
                              content={tabsIconsConsentForms}
                          />
                      </Tab.Pane>
                      <Tab.Pane eventKey="Submissions">
                          <Card
                              title="Manage Submissions"
                              category="Help Documentation for managing your submissions"
                              ctFullWidth
                              content={tabsIconsSubmissions}
                          />
                      </Tab.Pane>
                      <Tab.Pane eventKey="FAQ">
                          <Card
                              title="Frequently Asked Questions"
                              category="FAQs with some great answers!"
                              ctFullWidth
                              content={tabsIconsFAQ}
                          />
                      </Tab.Pane>

                  </Tab.Content>
              </div>
          </Tab.Container>
      );
      if (this.props.userLoggedIn[0].status) {
          return (
              <div className="main-content" style={{backgroundImage: "url("+require("../../assets/img/matrix.jpg")+")", backgroundSize: "cover",
                  backgroundPosition: "center center"}}>
                  {/*<div className="main-content">*/}
                  <Grid fluid>
                      <Row>
                          <Col md={10} mdOffset={1}>
                              <h2 className="title text-center">Welcome to TRO Online Help</h2>
                              <br />
                              {pageSubcategories}
                          </Col>
                      </Row>

                  </Grid>
              </div>
          );
    }
    else {
        alert("You must be logged in and have an active subscription to access this page!");
        this.context.router.history.push("/pages/login-page");
        return (null);
    }

  }
}
OnlineHelp.propTypes = {
    loginActions: PropTypes.object.isRequired,
    userLoggedIn: PropTypes.array.isRequired,
};

function mapStateToProps(state, ownProps) {
    return {
        userLoggedIn: state.userLoggedIn,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loginActions: bindActionCreators(loginActions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(OnlineHelp);




// WEBPACK FOOTER //
// ./src/views/Dashboard/Help.jsx